//DFS...

export function dfs(graph) {
    const visitedNodesIdInOrder = [];
    let stack = [];
    const startNodeId = graph.startNode
    stack.push(startNodeId); 
    while (stack.length > 0) {
        let visiting = stack.pop();
        if (graph.list[visiting].isVisited === false) {
            graph.list[visiting].isVisited = true;
            visitedNodesIdInOrder.push(visiting);
            for (let p = graph.list[visiting].getHead(); p !== null; p = p.next) {
                var w = p.id
                stack.push(w);
                if (graph.list[w].isVisited === false)
                    graph.list[w].previousNodeId = visiting;
            }
        }
    }
    return visitedNodesIdInOrder;
}